import React, { memo, useMemo } from "react";
import { Blok } from "../../interfaces/Blok.interface";
import { StoryblokAsset } from "../../interfaces/StoryblokAsset.interface";
import StructuredData from "../StructuredData/StructuredData";

interface ProductStructuredDataBlokProps extends Blok {
  name: string;
  description: string;
  image: StoryblokAsset;
  brand: string;
  rating_value: string;
  best_rating: string;
  worst_rating: string;
  rating_count: string;
}

interface ProductStructureDataProps {
  blok: ProductStructuredDataBlokProps;
}

const ProductStructuredData: React.FC<ProductStructureDataProps> = ({
  blok
}) => {
  const {
    name,
    description,
    image,
    brand,
    rating_value,
    best_rating,
    worst_rating,
    rating_count
  } = blok;

  const productStructuredData = useMemo(() => {
    return {
      "@type": "Product",
      name: name,
      image: image?.filename,
      description: description,
      brand: {
        "@type": "Brand",
        name: brand
      },
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: rating_value,
        bestRating: best_rating,
        worstRating: worst_rating,
        ratingCount: rating_count
      }
    };
  }, [blok]);

  return <StructuredData>{productStructuredData}</StructuredData>;
};

export default memo(ProductStructuredData);
